import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { loadHostDetail } from '../actions';
import { metricKeys } from '../constants';
import { responseLogWithNotification } from '../../../utils/utils';
import ParkingMeterPopup from './ParkingMeterPopup';
import { optionClassFormatter } from '../../../utils/formatters';
import { sortByStatus } from '../parking-meter-utils';
import Tooltip from '../../../components/base/Tooltip/Tooltip';

export default function ParkingMeterMatrix(props) {
  const {
    hostStatusesList = [],
    hostDetail,
  } = props;
  const [showParkingMeter, setShowParkingMeter] = useState(false);
  const dispatch = useDispatch();
  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      interactiveScrollbars: true,
      preventDefault: false,
    });
    setScroll(a);
  }, []);
  useEffect(() => {
    if (scroll) {
      scroll.refresh();
    }
  }, [hostStatusesList]);
  const onMarkerClick = item => {
    dispatch(loadHostDetail({ id: item.id, metricKeys })).then(() => {
      setShowParkingMeter(true);
    }).catch(responseLogWithNotification);
  };
  const list = hostStatusesList.sort(sortByStatus);
  return (
    <div className="scroll-wrapper" id="scroll-wrapper">
      <div className="scroll">
        <div className="frame matrix-frame position-relative g-0">
          <div className="matrix-wrapper">
            {list.map((item, key) => (
              <div key={key} onClick={() => { onMarkerClick(item); }} className={classNames('matrix-element', optionClassFormatter(item.status))}>
                <Tooltip content={item.host} />
              </div>
            ))}
          </div>
          {showParkingMeter ? <ParkingMeterPopup item={hostDetail} handleClose={() => setShowParkingMeter(false)} /> : null}
        </div>
      </div>
    </div>
  );
}
